import { useState } from "react";
import "../../forms-style.scss";
import UserServiceApi from "../../Services/UserService";
import "../../forms-style.scss";
import ButtonComponent from "../../Components/Shared/ButtonComponent";
import { validateUserPassword } from "../../Validators/GenericValidator";
import InputType from "../../Components/Shared/InputType";
import { useSearchParams, useNavigate } from "react-router-dom";
import { ROUTE_CONSTANT } from "../../Util/Constants";

type Props = {};

const ResetPassword = (props: Props) => {
  const [newPassword, setNewPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [passwordError, setPasswordError] = useState(false);
  const [passwordErrorMsg, setPasswordErrorMsg] = useState("");
  const [disableBtn, setdisableBtn] = useState(false);
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();

  const onNewPasswordHandler = (e: { target: { value: any } }) => {
    const {
      target: { value },
    } = e;
    setNewPassword(value);
  };
  const onConfirmPasswordHandler = (e: { target: { value: any } }) => {
    const {
      target: { value },
    } = e;
    setConfirmPassword(value);
  };
  const validateData = () => {
    setPasswordError(false);
    let errors = 0;

    const passwordValidator = validateUserPassword(newPassword);
    if (passwordValidator.isValid === false) {
      ++errors;
      setPasswordError(true);
      setPasswordErrorMsg(passwordValidator.errorMessage);
    }
    if (errors > 0) {
      ++errors;
      setdisableBtn(false);
      return false;
    } else {
      setdisableBtn(true);
      return true;
    }
  };
  const token = searchParams.get("cd");
  const userGuid = searchParams.get("uid");

  const onResetPass = () => {
    if (newPassword !== confirmPassword) {
      setPasswordErrorMsg("new password and confirm password does not match");
    } else {
      const isValid = validateData();
      if (isValid) {
        const params = {
          newPassword: confirmPassword,
          token: token,
          userGuid: userGuid,
        };
        const ResetPasswordResponse = UserServiceApi.resetPassword(params)
          .then((userResponse: any) => {
            if (userResponse) {
              navigate(ROUTE_CONSTANT.SIGNIN);
              console.log("inside forgotPassword");
              //dispatch(savePersonalInfoSuccess(response.data.docGuid));
            } else {
              //dispatch(savePersonalInfoFailure(response.data));
            }
            return userResponse;
          })
          .catch((error) => {
            console.log("Error");
            return error.response.statusText;
          });
        console.log("params", params);
      }
    }
  };

  return (
    <>
      <section className="signup_section container-bg-color">
        <div className="container">
          <div className="signup_inner signin_inner">
            <div className="signup_border">
              <div className="signup_border__inner signup_border__inner--signin">
                <h1>Reset Password</h1>
                <p className="form-signin-heading text-center">
                  Please enter a new password. Remember that your password needs to be at least six characters in
                  length.
                </p>
                <div className="alert-danger">
                  {passwordError && (
                    <p style={{ color: "red" }} key="pswrdErr" className="alert error signup-error-message">
                      {/* <span>error prohibited this user from being saved:</span>
                                    <br /> */}
                      {passwordError && <small key="pswrdErr">{passwordErrorMsg}</small>}
                    </p>
                  )}
                </div>
                <div className="input_area">
                  <div className="form-group mb-2">
                    <InputType
                      inputProps={{
                        id: "NewPasswordTextBox",
                        text: "Password",
                        type: "password",
                        className: "form-control input-lg password",
                        index: 0,
                        name: "New password",
                        placeholder: "New Password",
                        value: newPassword || "",
                      }}
                      changeHandler={onNewPasswordHandler}
                    />
                  </div>
                  <div className="form-group mb-2">
                    <InputType
                      inputProps={{
                        id: "ConfirmPasswordTextBox",
                        text: "Password",
                        type: "password",
                        className: "form-control input-lg password",
                        index: 0,
                        name: "Confirm password",
                        placeholder: "Confirm Password",
                        value: confirmPassword || "",
                      }}
                      changeHandler={onConfirmPasswordHandler}
                    />
                  </div>
                  <div className="bounce-effect">
                    <ButtonComponent
                      buttonProps={{
                        disabled: disableBtn,
                        className: "btn primary-button btn-orange-signup",
                        text: "CONFIRM NEW PASSWORD",
                        id: "registerBtn",
                      }}
                      clickHandler={onResetPass}
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};
export default ResetPassword;
